<template>
  <button class="navbar-toggler" type="button" data-toggle="collapse" :data-target="target" :aria-controls="target"
    :aria-expanded="toggled" aria-label="Toggle navigation">
    <span class="fa fa-bars navbar-toggler-bar"></span>
  </button>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>
<style>
@media only screen and (max-width: 280px) {
  .navbar-brand img {
    height: 45px !important;
  }
}
</style>
